<template>
    <div class="section-container w-100 mt-4">
        <SprintCountOverTime :sessions="sessions" :selectedReferenceGroupText="selectedReferenceGroupText"
            :sprintData="sprintData" :hsrData="hsrData" :comparisonData="comparisonCountsData"
            :speedTypeThresholds="speedTypeThresholds" :distanceBands="distanceBands">
            <template #shared-info>
                <SharedInfoText />
            </template>
            <template #legend>
                <LongitudinalChartLegend :referenceGroupText="positionReferenceGroupText" />
            </template>
        </SprintCountOverTime>
    </div>
</template>

<script>
import { positionReferenceGroupText, selectedReferenceGroupText } from "./referenceGroupText";
import SharedInfoText from "./SharedInfoText";

export default {
    props: {
        sessions: Array,
        sprintData: Object,
        hsrData: Object,
        comparisonCountsData: Object,
        speedTypeThresholds: Object,
        distanceBands: Array
    },
    components: {
        SharedInfoText
    },
    computed: {
        selectedReferenceGroupText() {
            return selectedReferenceGroupText();
        },
        positionReferenceGroupText() {
            return positionReferenceGroupText();
        }
    },
};
</script>